var _circle, _circle2, _circle3, _circle4, _circle5, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreditCardPrimaryMd = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 178,
  height: 142,
  fill: "none",
  viewBox: "0 0 178 142",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 64,
  r: 64,
  fill: "var(--utility-brand-200, black)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 6,
  r: 6,
  fill: "var(--utility-brand-100, black)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 112,
  r: 8,
  fill: "var(--utility-brand-100, black)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 36,
  r: 8,
  fill: "var(--utility-brand-100, black)"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 9,
  r: 5,
  fill: "var(--utility-brand-100, black)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-100, black)",
  d: "M20 22a6 6 0 0 1 6-6h126a6 6 0 0 1 6 6v74a6 6 0 0 1-6 6H26a6 6 0 0 1-6-6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-300, black)",
  d: "M32 38a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H34a2 2 0 0 1-2-2z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 42,
  r: 10,
  fill: "var(--utility-brand-400, black)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 42,
  r: 10,
  fill: "var(--utility-brand-300, black)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-300, black)",
  d: "M32 89a2 2 0 0 1 2-2h20a2 2 0 1 1 0 4H34a2 2 0 0 1-2-2M62 89a2 2 0 0 1 2-2h20a2 2 0 1 1 0 4H64a2 2 0 0 1-2-2M92 89a2 2 0 0 1 2-2h20a2 2 0 1 1 0 4H94a2 2 0 0 1-2-2M122 89a2 2 0 0 1 2-2h20a2 2 0 1 1 0 4h-20a2 2 0 0 1-2-2"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-400, black)",
  d: "M61 106c0-15.464 12.536-28 28-28s28 12.536 28 28-12.536 28-28 28-28-12.536-28-28"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--fg-white)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M89 101.333V106m0 4.667h.012M100.667 106c0 6.443-5.224 11.667-11.667 11.667S77.333 112.443 77.333 106 82.557 94.333 89 94.333s11.667 5.224 11.667 11.667"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: 178,
  height: 126,
  x: 0,
  y: 16,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "effect1_dropShadow_1182_1083"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1182_1083"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "effect2_dropShadow_1182_1083"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 20
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_1182_1083",
  result: "effect2_dropShadow_1182_1083"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_1182_1083",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "b",
  width: 72,
  height: 72,
  x: 53,
  y: 70,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_1182_1083"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_1182_1083",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreditCardPrimaryMd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CreditCardPrimaryMd.77f1f7cb8daa14e65708f2eda51a24f5.svg";